import * as React from 'react';
import { styles } from './styles';
import { DesignBucketShell, DesignBucketShellProps } from '../components/DesignBucketShell';
import { ThemeDesignShowcaseSectionConfig, SHOWCASE_CONSTANTS } from '../../..';
import { capitalize } from 'utils/strings';
import { DesignShowcase_designShowcase_organization_themes } from '@graphql/designShowcaseTypes';
import { BucketGroupOption } from '../components/BucketGroupOption';
import { InlineDialogProps } from '../../InlineDialog';
import { Columns } from '@joykit';

interface Props extends ThemeDesignShowcaseSectionConfig {
  onOptionSelect: React.MouseEventHandler<HTMLElement>;
  onCloseRequest: InlineDialogProps<null>['onCloseRequest'];
  options: DesignShowcase_designShowcase_organization_themes['buckets'];

  isMobile?: boolean;
}

export class ThemesBucket extends React.Component<Props & DesignBucketShellProps> {
  render() {
    const isMostPopularOptionSelected = this.props.showMostPopular;
    const valueString = isMostPopularOptionSelected
      ? 'All'
      : this.props.values
          .map(themeOption => {
            return capitalize(themeOption.displayString);
          })
          .join(', ');
    const value = this.props.values[0];
    return (
      <DesignBucketShell
        section="themes"
        label="Theme"
        isMobile={this.props.isMobile}
        open={this.props.open}
        onClose={this.props.onCloseRequest}
        subtitle={valueString}
        onTriggerClick={this.props.onTriggerClick}
        onResetClick={this.props.onResetClick}
      >
        <DesignBucketShell.Content className={styles.container}>
          <Columns multiline={true}>
            <Columns.Column tablet={5}>
              <BucketGroupOption
                section="themes"
                value={SHOWCASE_CONSTANTS.THEME_MOST_POPULAR}
                onClick={this.props.onOptionSelect}
                ariaLabel={`Toggle All`}
                className={styles.themeLink(isMostPopularOptionSelected)}
              >
                All
              </BucketGroupOption>
            </Columns.Column>
            {this.props.options.map((themeOption, index) => {
              const indexIncludingMostPopular = index + 1;
              if (themeOption) {
                return (
                  <Columns.Column
                    key={indexIncludingMostPopular}
                    tablet={5}
                    tabletOffset={indexIncludingMostPopular % 2 === 1 ? 1 : undefined}
                  >
                    <BucketGroupOption
                      section="themes"
                      value={themeOption.bucketId}
                      onClick={this.props.onOptionSelect}
                      ariaLabel={`Toggle ${themeOption.displayString}`}
                      className={styles.themeLink(!!value && value.bucketId === themeOption.bucketId)}
                    >
                      {themeOption.displayString}
                    </BucketGroupOption>
                  </Columns.Column>
                );
              }
              return null;
            })}
          </Columns>
        </DesignBucketShell.Content>
      </DesignBucketShell>
    );
  }
}
